import React, { useEffect } from 'react'
import { Link } from "react-router-dom";



function MTechLeftTab() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);
  return (
    <div className="additional-information">
      <div className="list">
        <ul className="text-start">
          <Link to="/dept/m-tech">
            <li className="text-black">
              <i className="fa-solid fa-building-columns"></i>{" "}
              <span>About the Department</span>
            </li>
          </Link>

          {/* <Link to="#">
            <li className="text-black">
              <i className="fa-solid fa-bullseye"></i>{" "}
              <span>Vision, Mission & PEO’s</span>
            </li>
          </Link>

          <Link to="#">
            <li className="text-black">
              <i className="fa-solid fa-diagram-project"></i>{" "}
              <span>PO and PSO’s</span>
            </li>
          </Link>

          <Link to="#">
            <li className="text-black">
              <i className="fa-solid fa-user-tie"></i>{" "}
              <span>HOD Profile</span>
            </li>
          </Link> */}

          <Link to="/dept/m-tech/facultylist">
            <li className="text-black">
              <i className="fa-solid fa-chalkboard-user"></i>{" "}
              <span>Faculty List</span>
            </li>
          </Link>

          {/* <Link to="#">
            <li className="text-black">
              <i className="fa-solid fa-user-group"></i>{" "}
              <span>Mentor List</span>
            </li>
          </Link>

          <Link to="#">
            <li className="text-black">
              <i className="fa-solid fa-city"></i>{" "}
              <span>Infrastructure</span>
            </li>
          </Link> */}

          <Link to="/dept/m-tech/syllabus">
            <li className="text-black">
              <i className="fa-solid fa-book-open-reader"></i>{" "}
              <span>Syllabus</span>
            </li>
          </Link>

          {/* <Link to="#">
            <li className="text-black">
              <i className="fa-solid fa-clipboard-list"></i>{" "}
              <span>Remedial Class</span>
            </li>
          </Link>

          <Link to="#">
            <li className="text-black">
              <i className="fa-solid fa-road-bridge"></i>{" "}
              <span>Bridge Course</span>
            </li>
          </Link>

          <Link to="#">
            <li className="text-black">
              <i className="fa-solid fa-microphone-lines"></i>{" "}
              <span>Workshop and Seminar</span>
            </li>
          </Link>

          <Link to="#">
            <li className="text-black">
              <i className="fa-solid fa-list-check"></i>{" "}
              <span>Activities</span>
            </li>
          </Link>

          <Link to="#">
            <li className="text-black">
              <i className="fa-solid fa-calendar-days"></i>{" "}
              <span>Events</span>
            </li>
          </Link>

          <Link to="#">
            <li className="text-black">
              <i className="fa-solid fa-lightbulb"></i>{" "}
              <span>Innovative Teaching Methodologies</span>
            </li>
          </Link>

          <Link to="#">
            <li className="text-black">
              <i className="fa-solid fa-briefcase"></i>{" "}
              <span>Placements</span>
            </li>
          </Link> */}
        </ul>

      </div>
    </div>
  )
}

export default MTechLeftTab;



